export const surveyData = {
	v1: [
		{
			subject: 'Overall, how satisfied are you with the Creative Cloud website?',
			warning: '',
			answers: [
				'Very satisfied',
				'Somewhat satisfied',
				'Neither satisfied nor dissatisfied',
				'Somewhat dissatisfied',
				'Very dissatisfied',
			],
			shortAnswer: '',
			longAnswer: '',
		},
		{
			subject: 'What is your primary reason for visiting the Creative Cloud website today?',
			warning: '',
			answers: [
				'To download or install Creative Cloud apps',
				'To manage my account or subscription',
				'To purchase a subscription',
				'To get help from Adobe',
				'To access or manage my work',
				'To make something new',
				'To learn about an app or view tutorials',
				'Just browsing',
				'None of the above',
			],
			shortAnswer: 'Other (please specify)',
			longAnswer: '',
		},
		{
			subject: 'What were you trying to accomplish during your visit today?',
			warning: '',
			answers: [
				'To renew my subscription',
				'To add apps to my subscription',
				'To remove apps from my subscription',
				'To cancel my subscription',
				'To update billing information',
				'To reset Adobe ID password',
				'None of the above',
			],
			shortAnswer: 'Other (please specify)',
			longAnswer: '',
		},
		{
			subject: 'What do you like or dislike most about the Creative Cloud website?',
			warning: 'Please do not include any personal information.',
			answers: [],
			shortAnswer: '',
			longAnswer: 'Enter your comments here...',
		},
	],
};
